import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Icon } from '../Icon';
import { Types } from '../Themes';
import { TImages } from '../Themes/Images';

import Styles from './VFBackground.Styles';

const Header = ({ type, onClose, ...props }) => {
  return (
    <View style={Styles.headerContainer} accessibilityLabel={FoundationTestKeys.headerView}>
      <Icon
        type="image"
        name={TImages.VFLogo[type]}
        size={36}
        accessibilityLabel={FoundationTestKeys.VFLogo}
      />

      <TouchableWithoutFeedback onPress={onClose} {...props}>
        <View style={Styles.closeButtonContainerStyle}>
          <Icon
            type="image"
            name={TImages.ic_close[type]}
            size={24}
            accessibilityLabel={FoundationTestKeys.EIOCloseButton}
            testID={FoundationTestKeys.EIOCloseButton}
          />
        </View>
      </TouchableWithoutFeedback>
    </View>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf([Types.PRIMARY, Types.SECONDARY]),
  onClose: PropTypes.func,
};

export default Header;
